module.exports = __webpack_public_path__ + "static/img/5.4a48d6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/5.png
// module id = hjnM
// module chunks = 0